module.exports = __webpack_public_path__ + "static/img/level3.91b36cce.png";